{
  "titles": {
    "view": "Mijn gegevens",
    "update": "Gegevens aanpassen",
    "advisors": "Adviseurs"
  },
  "actions": {
    "update": "Gegevens aanpassen"
  },
  "messages": {
    "updateSuccess": "Je gegevens zijn succesvol opgeslagen."
  },
  "fields": {
    "labels": {
      "fullName": "Naam",
      "name": "Naam",
      "phone": "Telefoonnummer",
      "email": "E-mailadres"
    },
    "hints": {
      "phone": "Je tweestapsverificatie verandert niet wanneer je een nieuw nummer instelt.",
      "email": "Het is niet mogelijk je e-mail te wijzigen."
    }
  }
}
